'use client'

import { motion } from 'framer-motion'
import { ArrowRight, Check } from 'lucide-react'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { siteConfig } from '@/lib/constants'

const steps = [
  {
    title: 'Install Buddify',
    description: 'Install Buddify Brand Partnerships on your Shopify store',
  },
  {
    title: 'Set Up Your Profile',
    description: 'Configure your supplier profile with products and pricing',
  },
  {
    title: 'Go Live',
    description: 'Products appear on the Marketplace app automatically',
  },
  {
    title: 'Fulfill Orders',
    description: 'Process marketplace orders through your existing workflow',
  },
]

export function HowToGetListedSection() {
  return (
    <Section background="white" id="how-it-works">
      <Container size="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-display-1 text-ink mb-4">
            How to Get Listed
          </h2>
          <p className="text-lg text-muted">
            Getting your products on the marketplace takes just a few minutes
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Card className="max-w-2xl mx-auto">
            <CardContent className="p-8">
              <ol className="space-y-5">
                {steps.map((step, index) => (
                  <motion.li
                    key={step.title}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                    className="flex items-start gap-4"
                  >
                    <div className="w-8 h-8 bg-sky-500 rounded-full flex items-center justify-center flex-shrink-0 text-white font-semibold text-sm">
                      {index + 1}
                    </div>
                    <div className="flex-1 pt-0.5">
                      <h3 className="font-semibold text-ink mb-0.5">
                        {step.title}
                      </h3>
                      <p className="text-muted text-sm">{step.description}</p>
                    </div>
                    <Check className="w-5 h-5 text-brand-blue flex-shrink-0 mt-1" />
                  </motion.li>
                ))}
              </ol>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.7 }}
                className="mt-8 pt-6 border-t border-line"
              >
                <Button
                  href={siteConfig.links.shopifyApp}
                  external
                  className="w-full"
                  size="lg"
                  variant="marketplace"
                >
                  Get Started with Brand Partnerships
                  <ArrowRight className="w-5 h-5" />
                </Button>
              </motion.div>
            </CardContent>
          </Card>
        </motion.div>
      </Container>
    </Section>
  )
}
